export default function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] px-4">
      <div className="text-center max-w-sm space-y-4">
        <div className="text-4xl">😵</div>
        <h1 className="text-xl font-bold font-display text-[#111827]">Something went wrong</h1>
        <p className="text-sm text-[#6B7280]">
          An unexpected error occurred. The error has been automatically reported to our team.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="w-full py-3 rounded-full bg-[#5B4FE8] text-white font-medium hover:bg-[#4338CA] transition-colors"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}
